import { UserCollectionDataProvider } from '@steelbuy/data-provider';
import { AddUser } from '../../components/add-user/AddUser';

export const AddUserView = () => (
    <UserCollectionDataProvider lazyLoad>
        <AddUser />
    </UserCollectionDataProvider>
);
